import { Icon } from "leaflet";

const customIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#e13737" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M12 2C8.13401 2 5 5.13401 5 9C5 13.25 12 22 12 22C12 22 19 13.25 19 9C19 5.13401 15.866 2 12 2Z" stroke="#000000" stroke-width="2"/>
  <circle cx="12" cy="9" r="3" fill="#e13737" stroke="#000000" stroke-width="2"/>
</svg>
`;

export const customIcon = new Icon({
  iconUrl: `data:image/svg+xml;base64,${btoa(customIconSvg)}`, // Convert SVG markup to base64
  iconSize: [30, 30],
});